import { Link } from "@tanstack/react-router";

import Header from "@/components/header-v2";
import NotFoundBg from "@/components/icons/not-found-bg";
import { Button } from "@/components/ui/button";
import usePWA from "@/hooks/use-pwa";

export function NotFound() {
  const { homeHref } = usePWA();
  return (
    <>
      <title>Page not found!</title>
      <Header variant="simplified" />
      <div className="container">
        <div className="flex min-h-168 items-center justify-center py-[10vw]">
          <div className="w-full max-w-137.5">
            <div className="group relative -mb-48 p-8 text-center">
              <div className="absolute inset-0 z-1 bg-linear-to-r from-15% from-midnight-express to-70% to-transparent opacity-0 transition-opacity group-hover:opacity-0 md:opacity-100" />
              <h1 className="font-normal text-60 text-mint tracking-wide">
                404
              </h1>
              <h2 className="font-normal text-40 text-mint tracking-wide">
                Need a Hint?
              </h2>
              <p className="text-24 text-mint">Look for more clues elsewhere</p>
              <Button
                asChild
                className="relative z-20 mt-8 h-12 rounded-full bg-linear-to-r from-20% from-midnight-express via-40% via-tiber to-mint px-8 font-semibold text-16 text-gray-800 transition-opacity hover:opacity-100 md:opacity-50"
              >
                <Link to={homeHref}>Morty home</Link>
              </Button>
            </div>
            <NotFoundBg className="md:translate-x-32" />
          </div>
        </div>
      </div>
    </>
  );
}
